<template>
  <body>
    <div class="bes_list" v-if="!isInit">
        <div v-if="show_reapp">  
          <div class="app_invoice">
            <input type="button" value="重新申请" @click="appInvoice()" />
          </div>
        </div>
        <div v-else-if="show_continue">
          <div class="app_invoice">
            <input type="button" value="继续申请开票" @click="appInvoice()" />
          </div>
        </div>
        <div v-else-if="show_invalid"> 
          <div class="app_invoice">
            <input type="button" value="申请作废" @click="appCancel()" />
          </div>
        </div>
    <div v-if="invoiceList.length > 0">
        <div v-for="(docAppInfo, index) in invoiceList" :key="index" >
          <table>
            <tr class="line">
              <td class="bold"><p>开票状态：{{ statusList[docAppInfo.doc_app_id].status }}</p>
                  <div v-if="docAppInfo.doc_app.doc_status = 1">
                    <p>{{ statusList[docAppInfo.doc_app_id].checkTime }}</p>
                  </div>
              </td>
            </tr>
            <tr class="line">
              <td class="inf">
                <p>申请批次号：{{ docAppInfo.doc_app_id }}</p>
                <p>发票类型：{{ statusList[docAppInfo.doc_app_id].invoiceType }}</p>
                <p>发票代码：{{ statusList[docAppInfo.doc_app_id].prefix }}</p>
                <p>发票号码：{{ statusList[docAppInfo.doc_app_id].docNo }}</p> 
                <p>购买方名称：{{ docAppInfo.doc_app.head }}</p>
                <p>发票金额：￥{{ docAppInfo.doc_app.amount }}<p>
                <p>{{ statusList[docAppInfo.doc_app_id].timeStr }}</p>
              </td>
            </tr>
              <div v-if="docAppInfo.doc_app.check_status == 2">
                <span style="color: red;">失败原因：{{ docAppInfo.doc_app.check_remark }}</span>
              </div>
              <div v-else-if="docAppInfo.doc_app.check_status == 1 && docAppInfo.doc_app.doc_status == 0">
                <span style="color: red;">失败原因：由于网络中断导致无法正常同步开出电子普通发票</span>
              </div>
              <div v-else>
                <div class="bold" v-if="statusList[docAppInfo.doc_app_id].invoiceTypeStr == 0 && 
                    (statusList[docAppInfo.doc_app_id].kpPdfUrl != undefined && statusList[docAppInfo.doc_app_id].kpPdfUrl != '' )">
                  <a href="javascript:void(0)" style="float:right" @click="checkInvoice(statusList[docAppInfo.doc_app_id].kpPdfUrl)">查看发票 ></a>
                </div>
                <div v-else>
                  &nbsp;
                </div>
              </div>
          </table>
        </div>
      </div>
    </div>
    <div class="close_btn">
      <input class="inp" type="button" value="关闭" @click="close()">
    </div>
  </body>
</template>
<style scoped>
  @import '../../assets/css/pages/customer/css.css';
  .bes_list{background: #eee;}
  .bes_list table {font-size: 0.5em; margin: 1.2em auto; background: #fff; width: 98%;}
  .bes_list table tr td{padding: 2%;}
  .bes_list table tr td p{line-height: 150%;}
  .line{border-bottom: 1px solid #c9c9c9;}
  .bold{font-weight: bold;font-size: 20px;}
  .red{color: red;}
  .inf{font-size: 15px;}
  .inp{ background-color: #5595e3; border-radius: 5px; width: 90px; font-size: 10px; padding: 1% 1%; color: #fff;}
  .green{color: green;}
  .blue{color:#20B1FF;}
  .close_btn{text-align:center}
  .app_invoice{text-align: right; padding:1% 1%;}
  .app_invoice input{font-size: 15px; background: #5595e3;; font-weight:bold; padding: 1% 2%; border-radius: 0.3em; color: #fff;}
</style>

<script>
export default {
    data() {
      return {
        isInit: true,
        show_invalid: '', //作废按钮
        show_reapp: '', //重新开票按钮
        show_continue: '', //继续申请开票按钮 
        unAmount:'',
        amount:"",
        order_id:'',
        statusList:[],
        doc_status:'',
        check_status:'',
        app_status:'',
        source:'',
        invoiceList:[],
        time_str:'',
        kpPdfUrl:'',
        check_time:'',
      }
  },
  props: {
      orderInfo:{
      },
      invoiceInfo:{
      }
    },
  created(){
    this.order_id = this.orderInfo[0].order_info_id
    this.unAmount = this.orderInfo[0].uninvoice_amount
    this.doc_status = this.invoiceInfo.doc_status
    this.check_status = this.invoiceInfo.check_status
    this.source = this.orderInfo[0].source
    this.getInvoiceList()
    this.isShowInvalid()
  },
  methods:{
    getInvoiceList(){
      const url = '/doc_app/getInvoiceList/' + this.order_id
        var fields = this.$myGet(url, {})
        fields.then(res => {
          let invoiceList = res.response.data.invoiceList
          invoiceList.forEach(item =>{
            this.invoiceList.push(item)
            this.statusList[item.doc_app_id] = res.response.data[item.doc_app_id]
          })
          this.isReapp()
          this.isInit = false
        })
      },
      isShowInvalid() { //作废按钮显示
        let type = this.$loginType()
        if (type == 1) {  //会员登录
          //客人网购,发票状态为正常,发票已开票
          if (this.invoiceInfo.doc_status == 1 && this.invoiceInfo.status == 0 && this.orderInfo[0].order_info.from_www == 1) { 
            this.show_invalid = true
          }
        } else if (type == 0) { //销售登录
          //销售网购,发票状态为正常,发票已开票(什么情况status会为3？？？？)
          if (this.invoiceInfo.doc_status == 1 && this.invoiceInfo.status == 0 && this.orderInfo[0].order_info.from_www == 2) { 
            this.show_invalid = true
          }
        }
      },
      isReapp() { //重新申请，继续申请按钮显示
        if (this.invoiceList[0].doc_app.invoice_type == 0 && ((this.doc_status == 2 || this.check_status == 2) && this.unAmount > 0)) {
            this.show_reapp = true;
        } else if (this.unAmount > 0 && this.invoiceList[0].doc_app.invoice_type == 0) {
            this.show_continue = true;
        }
      },
      checkInvoice(e) { //查看发票地址
        window.location.href = e
      },
      appInvoice() {
        var table_ids = this.order_id + '@' + this.orderInfo[0].order_info.source
        this.$domUtils.dispatch(this, 'Invoice', 'cut.invoice', { order_id: table_ids, isShowInfo:  false, amount: this.unAmount,show_list:false,show_info:true })
      },
      appCancel() {
         this.$domUtils.dispatch(this, 'Invoice', 'cut.invoice', { order_id:this.order_id, invoiceList:this.invoiceList[0],show_list:false, show_invalid:true })
      },
      close() {
        this.$domUtils.dispatch(this, 'Invoice', 'cut.invoice', { closeDialog:true })
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/common/invoiceList.vue